import React , { useEffect, useState } from 'react';
import SplashScreen from '../components/SplashScreen';
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button, Modal } from 'react-bootstrap';
import { axiosNoAuth_IDENT_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import { translateAPIError } from '../utils/apiUtils';


const UserActivation = (props) => {

  const { i18n, t } = useTranslation(["common"]);

  const navigate = useNavigate();

  const [message, setMessage] = useState('');

  const [searchParams] = useSearchParams();
  const lng = searchParams.get("language");
  const encryptedActvToken = searchParams.get("token");

  // Initialize state
  useEffect(() => {
    i18n.changeLanguage(lng);
    activateUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const activateUser = () => {

    const reqBody = {
      encryptedActvToken: encryptedActvToken
    }

    return new Promise(async (resolve, reject) => {
      try {

        const res = await axiosNoAuth_IDENT_MGMT_API.post("activate-user-email-verified", reqBody);

        resolve(res.data);

        if (res.status === 200) {

          setMessage(t("I18N_Actv_successful"));
        } else {
          // ##### Handle other status code, if there is any #####

          setMessage(t("I18N_ERR_Std_500_Msg"));
        }
      } catch (error) {
        setMessage(t(translateAPIError(error)));
        //reject(error);
      }
    });
  }


  const handleClose = () => {
    navigate("/AdminHome/Login/" + lng);
  }

  return (
    <React.Fragment>

      <div>
        <SplashScreen />
      </div>

      <Modal show={true} onHide={handleClose} centered backdrop="static" >
        <Modal.Header closeButton>
          <Modal.Title style={{fontSize:'20px', fontWeight:'200'}}>
            {t("I18N_User_Activation")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{padding:'10px', fontSize:'15px'}}>
            <div style={{fontWeight:'200'}}>
              {message}
            </div>
            <Button variant="outline-secondary" size="sm" type="submit" className="mb-3" style={{marginTop:'15px', float:'right', fontWeight:'300'}} onClick={handleClose}>
              {t("I18N_Close")}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  )
}

export default UserActivation;
